/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { Limited, OffsetParams } from 'SharedDir/declarations/pagination';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import SERVICE_LLM, { serviceLLMUrl } from 'SharedDir/backend/endpoints/service-llm';
import { ServiceLLMChat, ServiceLLMChatMessageObject, ServiceLLMMessage } from 'SharedDir/declarations/service-llm';

export default class ServiceLLMApiClass extends SimpleApi<
  ServiceLLMChat,
  undefined
> {
  constructor() {
    super(serviceLLMUrl);
  }

  async getPaginatedChats(params: Partial<OffsetParams>) {
    const { data } = (await http({
      ...SERVICE_LLM.LIST,
      params
    })) as AxiosResponse<Limited<ServiceLLMChat>>;

    return data;
  }

  async getMessages(chatId: number, params: Partial<OffsetParams>) {
    const { data } = (await http({
      ...SERVICE_LLM.MESSAGE_LIST(chatId),
      params
    })) as AxiosResponse<Limited<ServiceLLMMessage>>;

    return data;
  }

  async createMessage(chatId: number, message: string) {
    const { data } = (await http({
      ...SERVICE_LLM.MESSAGE_CREATE(chatId),
      data: message,
    })) as AxiosResponse<ServiceLLMMessage>;

    return data;
  }

  async cancelMessage(chatId: number) {
    const { data } = (await http({
      ...SERVICE_LLM.MESSAGE_CANCEL(chatId),
    })) as AxiosResponse<ServiceLLMChatMessageObject>;

    return data;
  }
}
